import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const hobby = type => {
  return (
    <div className="container">
      {breadcrumbs(type, [{ href: "/voice2/", text: "お客様の声" }, { text: "趣味・コレクションの収納に" }])}
      
      <div className="hobby">
        <h1 id="useCaseContentsHead"><span>趣味・コレクションの収納に</span></h1>
        <div className="useCaseImg"><img src="resource/img/static/voice2/hobby/kv_03.jpg" alt="活用事例"/></div>
          <div id="useCaseVoiceArea">
            <div className="useCaseBox">
              <h2>駐車場がない問題を解消</h2>
              <div className="useCaseBoxInfo">
                <p className="useCaseName">バイク好きなK様</p>
                <p className="useCaseText">
                  駐輪場が無いアパートに住んでいて、どうしてもバイクが欲しくなって…、そんな時にハローストレージならバイクも収納できるということを知り、思い切って購入してしまいました。トランクルームに収納できることで、バイク盗難に対する不安からもなく安心しています。休日は早起きしてツーリング。 次回はどこに行こうかなど楽しみながら予定を立てたりして、おかげで休日がとても充実しています。
                </p>
              </div>
            </div>
          
          <div className="useCaseBox">
            <h2>趣味の音楽のアイテム整理に</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">音楽が趣味のN様</p>
              <p className="useCaseText">
                音楽関係の仕事をしているほか、趣味も音楽であるため、レコードやＣＤ、楽譜がたまる一方で、とても自宅では収納しきれなくなっていました。自宅に溢れていたレコードや楽譜をトランクルームへ移動・収納することにより、自宅の一部屋が倉庫状態になっていたものが解消でき、生活の空間が増えました。利用する前は、自宅の狭い部屋にレコードや楽譜を無理やり押し込んでいたため、時として必要になる資料（レコード・楽譜）を探し出すのに一苦労していましたが、トランクルームに整理して収納できたことで、資料探しも楽になり、必要なものがすぐ見つかるようになりました。私が借りているトランクルームは高さがあるので、背丈のある棚を並べることで、空間を有効利用し、大量のレコードや楽譜が収納できています。
              </p>
            </div>
          </div>
          
          <div className="useCaseBox">
            <h2>大好きな本の収納に</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">本が大好きなH様</p>
              <p className="useCaseText">
                とにかく本が好きで仕事も出版関係のため、自分が好きで購入した本と、仕事で必要となり保存している書籍もあるので、相当な量になってしまいました。処分したくない、処分できない大切な本の収納。家では限りがあるため、引越を機に、トランクルームを借りることにしました。一部屋多い賃貸物件を探すより、圧倒的にリーズナブルな価格です。住居には仕事で必要な本と、最近購入した本だけを置くようにしました。あとは、ダンボールに詰めてトランクルームへ。本に圧迫されない、快適な住居スペースとなりました。また、本には湿気が大敵。利用する前はトランクルームでの収納に不安もありましたが、まったく支障ありませんでした。むしろ、以前の住まいで配管の水漏れにより押し入れ内の本をダメにしてしまったことがあるので、かえって安心です。
              </p>
            </div>
          </div>
        </div>

        <div id="pageTopAreaBottom">&nbsp;</div>

        <div id="useCaseContentsLink">
          <h2>その他の活用事例</h2>
          <ul>
            <li><a href="/voice2/moving/"><img src="resource/img/static/voice2/hobby/use_case_01.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/moving/"><span>引越し・リフォームの際の一時収納に</span></a></div></li>
            <li><a href="/voice2/season/"><img src="resource/img/static/voice2/hobby/use_case_02.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/season/"><span>季節外用品・育児用品の収納に</span></a></div></li>
            <li><a href="/voice2/hobby/"><img src="resource/img/static/voice2/hobby/use_case_03.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/hobby/"><span>趣味・コレクションの収納に</span></a></div></li>
            <li><a href="/voice2/organization/"><img src="resource/img/static/voice2/hobby/use_case_04.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/organization/"><span>法人・団体の荷物収納に</span></a></div></li>
          </ul>
        </div>
        <p className="useCaseTextLink"><a href="/voice2/">⇒ お客様の声をみる</a></p>

        <div id="useCasePrefecturalLink">
          <a href="/">
            <div id="useCasePrefecturalLinkTitle"><img src="resource/img/static/voice2/hobby/use_case_cv_area_copy.png" alt=""/></div>
            <div id="useCasePrefecturalLinkButton">近くのトランクルームを探す</div>
          </a>
        </div>
      </div>
    </div >
  );
};



// WEBPACK FOOTER //
// ./pages/new/hobby.jsx